import { CONSTANTS } from '@pk/powerkioskutils';
import moment from 'moment-timezone';
import { ViewEnterpriseDashboardBudgetMonthDetail } from './view-enterprise-dashboard-budget-month-detail';

export class ViewEnterpriseDashboardBudgetMonth {
	public originContractId: string;
	public contractId: string;
	public agentId: string;
	public parentId: string;
	public contractNum: string;
	public originContractNum: string;
	public effectiveDate: Date;
	public expirationDate: Date;
	public confirmationDate: Date;
	public productId: string;
	public productName: string;
	public dbaName: string;
	public supplierId: string;
	public supplierName: string;
	public utilityIdList: string;
	public utilityNameList: string;
	public serviceTypeId: string;
	public serviceTypeName: string;
	public address1: string;
	public address2: string;
	public city: string;
	public stateId: string;
	public stateShort: string;
	public zipCode: string;
	public countryId: number;
	public countryName: string;
	public date: Date;
	public prevUsage: number;
	public prevSupplyRate: number;
	public prevBudgetDeliveryCost: number;
	public prevBudgetDeliveryAndTaxCost: number;
	public prevBudgetTaxCost: number;
	public prevSupplyCost: number;
	public prevBudgetCost: number;
	public usage: number;
	public supplyRate: number;
	public budgetDeliveryCost: number;
	public budgetTaxCost: number;
	public budgetDeliveryAndTaxCost: number;
	public supplyCost: number;
	public actualCost: number;
	public deliveryVarianceAmount: number;
	public taxVarianceAmount: number;
	public deliveryAndTaxVarianceAmount: number;
	public supplyVarianceAmount: number;
	public usageVarianceAmount: number;
	public deliveryVariancePercent: number;
	public taxVariancePercent: number;
	public deliveryAndTaxVariancePercent: number;
	public supplyVariancePercent: number;
	public usageVariancePercent: number;
	public varianceAmount: number;
	public variancePercent: number;
	public nextUsage: number;
	public nextSupplyRate: number;
	public nextBudgetDeliveryCost: number;
	public nextBudgetTaxCost: number;
	public nextBudgetDeliveryAndTaxCost: number;
	public nextSupplyCost: number;
	public nextBudgetCost: number;
	public nextBudgetPercent: number;
	public nextSupplyRatePercent: number;

	public details: ViewEnterpriseDashboardBudgetMonthDetail[];

	constructor(viewEnterpriseDashboardBudgetMonth: ViewEnterpriseDashboardBudgetMonth) {
		Object.assign(this, viewEnterpriseDashboardBudgetMonth);

		this.effectiveDate = this.effectiveDate ? new Date(moment(this.effectiveDate).format('MMM DD, YYYY 00:00:00 a')) : this.effectiveDate;
		this.expirationDate = this.expirationDate ? new Date(moment(this.expirationDate).format('MMM DD, YYYY 00:00:00 a')) : this.expirationDate;
		this.confirmationDate = this.confirmationDate ? new Date(moment(this.confirmationDate).format('MMM DD, YYYY 00:00:00 a')) : this.confirmationDate;

		this.details = [
			new ViewEnterpriseDashboardBudgetMonthDetail({
				label: 'Contracted Volume',
				prevBudget: this.prevUsage,
				actual: this.usage,
				varianceAmount: this.usageVarianceAmount,
				variancePercent: this.usageVariancePercent,
				nextBudget: this.nextUsage,
				nextBudgetPercent: this.usageVariancePercent,
			}),
			new ViewEnterpriseDashboardBudgetMonthDetail({
				label: 'Supply Cost',
				prevBudget: this.prevSupplyCost,
				actual: this.supplyCost,
				varianceAmount: this.supplyVarianceAmount,
				variancePercent: this.supplyVariancePercent,
				nextBudget: this.nextSupplyCost,
				nextBudgetPercent: this.supplyVariancePercent,
			}),
			new ViewEnterpriseDashboardBudgetMonthDetail({
				label: 'Delivery & Tax',
				prevBudget: this.prevBudgetDeliveryAndTaxCost,
				actual: this.budgetDeliveryAndTaxCost,
				varianceAmount: this.deliveryAndTaxVarianceAmount,
				variancePercent: this.deliveryAndTaxVariancePercent,
				nextBudget: this.nextBudgetDeliveryAndTaxCost,
				nextBudgetPercent: this.deliveryAndTaxVariancePercent,
			}),
		];

		const blendedSupplierRateLabel = [CONSTANTS.products.fixedAllInElectric, CONSTANTS.products.fixedAllInGas].includes(this.productId)
			? 'Supply Rate'
			: 'Blended Supply Rate';

		this.details.push(
			new ViewEnterpriseDashboardBudgetMonthDetail({
				label: blendedSupplierRateLabel,
				prevBudget: this.prevSupplyRate,
				actual: this.supplyRate,
				varianceAmount: ((this.supplyRate !== null && this.supplyRate !== 0 && this.nextSupplyRate !== null) ? Math.round((this.supplyRate - this.nextSupplyRate) * 1e12) / 1e12 : null),
				variancePercent: this.supplyRate !== null && this.supplyRate !== 0 && this.nextSupplyRate !== null ? Math.round(((this.supplyRate - this.nextSupplyRate) / this.supplyRate) * 1e12) / 1e12 : null,
				nextBudget: this.nextSupplyRate,
				nextBudgetPercent: this.nextSupplyRatePercent,
			}),
		);
	}
}
